import React, { useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../images/contact-img.svg";
import emailjs from "emailjs-com";
import navIcon1 from "../images/nav-icon1.svg";
import navIcon2 from "../images/nav-icon2.svg";
import navIcon3 from "../images/nav-icon3.svg";

const Contact = () => {
  const form = useRef();

  const [buttonText, setButtonText] = useState("Send");

  function handleSubmit(e) {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_5mqx13q",
        "template_zjdqxtw",
        form.current,
        "7_eqmP08KWzIAlibG"
      )
      .then(
        (result) => {
          setButtonText("Thank you!");
          console.log(result.text);
        },
        (error) => {
          setButtonText("ERROR");
          console.log(error.text);
        }
      );
  }

  return (
    <section className="contact" id="contact">
      <Container>
        <Row className="align-items-center">
          <Col md={6}>
            <img src={contactImg} alt="Contact Me" />
          </Col>

          <Col md={6}>
            <h2 className="text-center">Contact me!</h2>
            <form ref={form} onSubmit={handleSubmit}>
              <Row>
                <Col sm={6} className="px-1">
                  <input
                    type="text"
                    name="first-name"
                    placeholder="First Name"
                  />
                </Col>
                <Col sm={6} className="px-1">
                  <input type="text" name="last-name" placeholder="Last Name" />
                </Col>
                <Col sm={6} className="px-1">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                  />
                </Col>
                <Col sm={6} className="px-1">
                  <input type="tel" name="phone" placeholder="Phone" />
                </Col>
                <Col style={{ padding: "0px 4px" }}>
                  <textarea name="message" rows="6" placeholder="Message" />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    <button type="submit">
                      <span>{buttonText}</span>
                    </button>
                  </div>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
        <footer className="footer">
          <Container>
            <Row className="align-item-center">
              <Col sm={6}></Col>
              <Col sm={6} className="text-center text-sm-end">
                <div className="social-icon">
                  <a
                    href="https://www.linkedin.com/in/pawelnietupski/"
                    target="_blank"
                  >
                    <img src={navIcon1} alt="" />
                  </a>
                  <a href="https://github.com/p-niet" target="_blank">
                    <img src={navIcon2} alt="" id="githubicon" />
                  </a>
                  <a href="https://www.facebook.com/paszczuh/" target="_blank">
                    <img src={navIcon3} alt="" />
                  </a>
                </div>
                <p>Copyright 2022. All Right Reserved</p>
              </Col>
            </Row>
          </Container>
        </footer>
      </Container>
    </section>
  );
};

export default Contact;
